/* eslint-disable no-shadow,no-param-reassign */
const state = {
  drawer: false,
  snackBar: false,
  snackBarColor: 'red',
  snackBarText: '',
  showNewVatCard: false,
};

const getters = {
  drawerOpened: (state) => state.drawer,
  snackBarColor: (state) => state.snackBarColor,
  snackBarText: (state) => state.snackBarText,
  snackBar: (state) => state.snackBar,
  showNewVatCard: (state) => state.showNewVatCard,
};

const mutations = {
  setDrawerState(state, payload) {
    state.drawer = payload;
  },
  snackBarState(state, payload) {
    state.snackBar = payload;
  },
  snackBarColor(state, payload) {
    state.snackBarColor = payload;
  },
  snackBarText(state, payload) {
    state.snackBarText = payload;
  },
  setShowNewVatCard(state, payload) {
    state.showNewVatCard = payload;
  },
};

const actions = {
  setDrawerStateAction({ commit }, drawerState) {
    commit('setDrawerState', drawerState);
  },
  setSnackBarStateAction({ commit }, { color, snackBar, text }) {
    commit('snackBarState', snackBar);
    commit('snackBarColor', color);
    commit('snackBarText', text);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
